<template>
   <li>
      <!--
         Voce di menu della sidebar.
         - locked=false → <router-link> verso `to` (comportamento normale)
         - locked=true  → <a> che emette `lockedEvent` sul $root (es. apertura dialog acquisto) e mostra il lucchetto
         L'icona si passa una sola volta tramite lo slot #icon.
      -->
      <component :is="locked ? 'a' : 'router-link'" :to="locked ? undefined : to" :class="{ 'm-0': locked }" @click="onClick">
         <span class="icon p-0">
            <slot name="icon"></slot>
         </span>
         <span>
            {{ label }}
            <span v-if="locked" class="mif-lock ml-1"></span>
         </span>
      </component>
   </li>
</template>

<script>
export default {
   name: "SidebarItem",
   props: {
      // Rotta di destinazione quando la voce è sbloccata
      to: { type: String, default: null },
      // Etichetta testuale della voce
      label: { type: String, default: "" },
      // Se true, la voce è "bloccata": non naviga ma emette lockedEvent e mostra il lucchetto
      locked: { type: Boolean, default: false },
      // Evento emesso su $root al click quando locked=true
      lockedEvent: { type: String, default: "OPENBUYDIALOG" }
   },
   methods: {
      onClick() {
         if (this.locked) this.$root.$emit(this.lockedEvent);
      }
   }
};
</script>
